export enum ShippingTypes {
    STANDARD = 'STANDARD',
}
